import { LitElement, PropertyValueMap, html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { sendEventNotificationClick, sendEventNotificationCloseClick } from '../utils/analytics';

export class AwardNotification extends LitElement {
  @property({ type: String }) type = '';
  @property({ type: String }) title = '';
  @property({ type: String }) subtitle = '';
  @property({ type: Number }) lifeTime = 5000;
  @property({ type: Number }) animationEndDelayTime = 500;
  @property({ type: String }) closingAnimationName = 'fadeOut';
  @property({ type: String }) navigateTo = '/user/minhas-conquistas/';

  @state() closing = false;
  @state() clicked = false;

  private timeout: number | null = null;

  createRenderRoot() {
    return this;
  }
  
  protected firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.firstUpdated(_changedProperties);
    this.timeout = window.setTimeout(() => {
      this.close();
    }, this.lifeTime);
  }

  _clearTimeout() {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  _handleCloseClick() {
    sendEventNotificationCloseClick({ type: this.type });
    this.close();
  }

  _handleAchievementClick() {
    this._clearTimeout();
    sendEventNotificationClick({ type: this.type });
    if (location.pathname.includes(this.navigateTo)) {
      return this.close();
    }

    if (this.closing || this.clicked) return;
    this.clicked = true;
    this.classList.add('clicked', 'closing');
    this.dispatchEvent(new CustomEvent('notification-click'))
    this.waitAnimationEnd(() => {
      location.assign(this.navigateTo);
    });
  }

  close() {
    if (this.closing || this.clicked) return;
    this.closing = true;
    this.classList.add('closing');
    this.waitAnimationEnd(() => {
      this.dispatchEvent(new CustomEvent('complete'));
    });
  }

  waitAnimationEnd(callback: () => void) {
    this.addEventListener('animationend', (e) => {
      if (e.animationName === this.closingAnimationName && e.target === this) {
        setTimeout(() => {
          callback?.();
        }, this.animationEndDelayTime);
      }
    });
  }

  render() {
    return html`
      <div class="award-image" @click=${this._handleAchievementClick}></div>
      <div class="award-info" @click=${this._handleAchievementClick}>
        <span class="award-title">${this.title}</span>
        <p class="award-subtitle">${this.subtitle}</p>
      </div>
      <button 
        type="button" 
        class="close-button" 
        title="Fechar Notificação" 
        @click="${this._handleCloseClick}" 
        ?disabled=${this.closing}
      >
        <span class="icon"></span>
      </button>
    `;
  }
}

const elementName = 'award-notification';
if (!customElements.get(elementName)) {
  customElements.define(elementName, AwardNotification);
}
